import { defineStore } from "pinia";

export const useFeedStore = defineStore("feed-store", {
  state: () => ({
    feeds: [],
    feedSourceIds: [],
    loadingFeedSources: {},
  }),
  getters: {
  },
  actions: {
    loadMoreFeedSources(feedId, lastFeedSourceId) {
      this.loadingFeedSources[feedId] = true;
      this.apiGet(
        `/feeds/${feedId}/sources`,
        {
          last_feed_source_id: lastFeedSourceId,
        },
        data => {
          const index = this.feeds.findIndex(feed => feed.feed_id === feedId);
          this.feeds[index].sources.items.concat(data.items);
          this.feeds[index].sources.has_more = data.has_more;

          this.loadingFeedSources[feedId] = false;
        },
      );
    },
  },
});
